import { colors } from "../design-tokens/colors";

import { getDefaultHeight, SVG } from "./utils";

type Props = {
  accentColor?: string;
} & React.SVGProps<SVGSVGElement>;

export const LockedDocumentIcon: React.FC<Props> = ({
  accentColor = colors.accent(),
  ...svgProps
}) => {
  return (
    <SVG
      viewBox="0 0 162.027 184.28"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 184.28)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
    >
      <filter
        id="a"
        filterUnits="userSpaceOnUse"
        height="184.282"
        width="162.027"
        x="0"
        y="0"
      >
        <feOffset />
        <feGaussianBlur result="blur" stdDeviation="15" />
        <feFlood floodOpacity=".161" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <g transform="translate(25.294 45)">
        <ellipse
          cx="58.134"
          cy="69.593"
          fill="#fff"
          opacity=".1"
          rx="58.134"
          ry="56.407"
        />
        <g filter="url(#a)" transform="translate(-25.29 -45)">
          <g fill="#fff" stroke="#e0e0e0" transform="translate(45 45)">
            <rect height="94.282" rx="2" width="72.027" stroke="none" />
            <rect
              fill="none"
              height="93.282"
              rx="1.5"
              width="71.027"
              x=".5"
              y=".5"
            />
          </g>
        </g>
        <g fill="#fff" stroke="#e0e0e0">
          <rect
            height="93.623"
            rx="2"
            width="72.027"
            x="25.821"
            y="6.593"
            stroke="none"
          />
          <rect
            fill="none"
            height="92.623"
            rx="1.5"
            width="71.027"
            x="26.321"
            y="7.093"
          />
        </g>
        <path d="M40.09 24.395h26.5v5.275h-26.5z" fill={accentColor} />
        <g fill="#707070">
          <path
            d="M40.09 36.262h44.167v1.978H40.09zM40.09 54.723h44.167v1.978H40.09zM40.09 40.878h44.167v1.978H40.09zM40.09 59.338h44.167v1.978H40.09zM40.09 45.493h44.167v1.978H40.09zM40.09 63.954h44.167v1.978H40.09z"
            opacity=".268"
          />
        </g>
        <circle cx="97.593" cy="103.5" fill={accentColor} r="26.5" />
        <path
          d="m98.34 105.726 2.26-2.23 1.566.418a1.412 1.412 0 0 0 1.673-1.742l-.418-1.555.73-.675 1.561.417a1.419 1.419 0 0 0 1.682-1.733l-.418-1.555a2.094 2.094 0 0 0-2.964-2.959l-8.634 8.655a5.586 5.586 0 1 0 2.963 2.959z"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <ellipse
          cx="92.414"
          cy="108.684"
          fill="none"
          rx="1.69"
          ry="1.688"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </SVG>
  );
};
